import React from 'react';
import styles from '../../pages/CheckoutPage.module.css';

/** Order summary panel — shows product name, amount breakdown, and security badges. */
function OrderSummary({ productName, amount, currency = 'INR' }) {
  const display = `₹${Number(amount).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

  return (
    <div className={styles.orderSummary}>
      <h3 className={styles.orderSummaryTitle}>Order Summary</h3>

      <div className={styles.orderSummaryRow}>
        <span className={styles.orderSummaryLabel}>{productName || 'AstroShubh Service'}</span>
        <span className={styles.orderSummaryAmount}>{display}</span>
      </div>

      <div className={styles.orderSummaryDivider} />

      <div className={styles.orderSummaryRow}>
        <span className={styles.orderSummaryLabel} style={{ fontWeight: 600 }}>Total Payable</span>
        <span className={`${styles.orderSummaryAmount} ${styles.orderSummaryTotal}`}>{display}</span>
      </div>

      <div className={styles.securityBadges}>
        <span className={styles.badge}>🔒 Secure</span>
        <span className={styles.badge}>✅ 256-bit SSL</span>
        <span className={styles.badge}>🏦 RBI Compliant</span>
      </div>
    </div>
  );
}

export default OrderSummary;
